import { IGoogleMapParams } from './IGoogleMapParams';

export { IGoogleMapParams };
